import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password-with-image',
  templateUrl: './forgot-password-with-image.component.html',
  styleUrls: ['./forgot-password-with-image.component.scss']
})
export class ForgotPasswordWithImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
